<div class="carousel-wrapper" #carouselWrapper>
<div class="carousel" *ngIf="!showGrid">
    <div class="carousel-container">
      <div *ngFor="let item of (cards | slice:0:4)" class="carousel-cell" [style.flex]="'0 0 ' + (100 / cant) + '%'">
        <!-- item general -->
        <a [href]="item.link ? '/es' + item.link : '#'"  target="_blank" rel="noopener noreferrer" class="carrera-card">
         
          <img *ngIf="item.redirectCard"  [src]="item.pathRedirect" [alt]="item.titulo || item.title" class="card-bg-img desk" onerror="this.src='./assets/img/default.png'">
         
          <img *ngIf="!item.redirectCard"  [src]="item.path" [alt]="item.titulo || item.title" class="card-bg-img desk" onerror="this.src='./assets/img/default.png'">
          <img *ngIf="!item.redirectCard"  [src]="item.path" [alt]="item.titulo || item.title" class="card-bg-img mob" onerror="this.src='./assets/img/default.png'">
         
         
          <div *ngIf="!item.redirectCard" class="card-overlay" [style.background-color]="(posgrado)? '#9B8D62E5' : data?.venue?.color" > 
            <h3 class="card-title quicksand-bold long-title ">
              {{ item.titulo || item.title }}
            </h3>
          </div>
          <div *ngIf="item.redirectCard" class="card-overlay posgrado desk" [style.background-color]="'transparent'"> 
                <h3 class="card-title quicksand-bold long-title ">
                  Conocé toda la oferta academica 
                </h3>
                <div  class="ver-mas" (click)="goCarrers()">
                  <a [href]="linkCarrers"  target="_blank" rel="noopener noreferrer" >
                    <span class="quicksand-bold">VER CARRERAS </span>
                  </a>
               </div>
          </div>
       <div *ngIf="item.redirectCard" class="card-overlay posgrado mob card-container"> 
              <img [src]="item.pathRedirectMobile || './assets/img/default.png'" 
                  alt="Fondo" 
                   class="card-bg-img" 
                   onerror="this.src='./assets/img/default.png'">

                <div class="info">
                  <h3 class="card-title quicksand-bold long-title ">
                   Conocé toda la oferta academica
                  </h3>
                  <div class="ver-mas" (click)="goCarrers()">
                   <a [href]="linkCarrers" target="_blank" rel="noopener noreferrer">
                       <span class="quicksand-bold">VER CARRERAS</span>
                   </a>
                 </div>
               </div>
          </div>
        </a>
      </div>
    </div>
  </div>

  <!-- VISTA 2: GRID DESPLEGADO -->
  <div class="carreras-grid" *ngIf="showGrid">
    <!-- Se cambia item.systemTitle por item.link concatenado con /es/ -->
    <a [href]="item.link ? '/es' + item.link : '#'" target="_blank" 
           rel="noopener noreferrer" class="carrera-card" *ngFor="let item of cards">
      <img [src]="item.path" [alt]="item.titulo || item.title" class="card-bg-img"
        onerror="this.src='./assets/img/default.png'">
      <div class="card-overlay" [style.background-color]="(posgrado)? '#9B8D62E5' : data?.venue?.color">
        <h3 class="card-title quicksand-bold long-title" >
          {{ item.titulo || item.title }}
        </h3>
      </div>
    </a>
  </div>
  
  <hr class="divider desk" [style.background-color]="data?.venue?.color" >
  <hr class="divider mob" [style.background-color]="data?.venue?.color" style="margin: 20px 0px 0px 0px!important;">
  <!-- BOTÓN VER MÁS / VER MENOS -->
  <div *ngIf="!posgrado" class="ver-mas" (click)="toggleView()">
    <span [style.color]="data?.venue?.color" class="quicksand-bold">{{ showGrid ? 'Ver -' : 'Ver +' }}</span>
  </div>

 
</div>
